<template>
  <nav class="navbar custom-navbar navbar-expand-lg">
    <div class="container">
      <button
        ref="navbarToggler"
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div ref="navbarNav" class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" to="/" @click="closeMobileMenu">O nás</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/teams" @click="closeMobileMenu">Týmy</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/results" @click="closeMobileMenu">Tabulky a statistiky</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/free-agents" @click="closeMobileMenu">Trh s hráči</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/schedule" @click="closeMobileMenu">Rozpis</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/rules" @click="closeMobileMenu">Pravidla</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/documents" @click="closeMobileMenu">Dokumenty</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/dk" @click="closeMobileMenu">Vedení ligy</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/sponsors" @click="closeMobileMenu">Sponzoři</router-link>
          </li>
          <!-- 
          <li class="nav-item">
            <router-link class="nav-link" to="/gallery">Galerie</router-link>
          </li>
          -->
          

          
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/admin" @click="closeMobileMenu">Administrace</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="main-bg">
    <div class="container main-container">
      <router-view></router-view>
    </div>
  </div>
  
  <app-footer></app-footer>
</template>

<script>
import AppFooter from './components/AppFooter.vue'
import { Collapse } from 'bootstrap';

export default {
  name: 'App',
  components: {
    AppFooter
  },
  watch: {
    $route() {
      this.closeMobileMenu();
    }
  },
  methods: {
    closeMobileMenu() {
      if (window.innerWidth >= 992) return;
      const nav = this.$refs.navbarNav;
      const toggler = this.$refs.navbarToggler;
      if (!nav || !nav.classList.contains('show')) return;

      const collapse = Collapse.getOrCreateInstance(nav);
      collapse.hide();

      if (toggler) {
        toggler.setAttribute('aria-expanded', 'false');
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

body, #app, .main-bg {
  background: #0a1023 !important;
  color: #e0e6f7;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.custom-navbar {
  background: rgba(19, 27, 54, 0.75) !important;
  backdrop-filter: blur(16px) saturate(1.6);
  -webkit-backdrop-filter: blur(16px) saturate(1.6);
  border-bottom: 1px solid rgba(31, 224, 255, 0.13);
  box-shadow: 0 2px 16px rgba(10, 16, 35, 0.4);
  padding: 0.5rem 0;
  position: sticky;
  top: 0;
  z-index: 1030;
}

.navbar-brand {
  color: #1fe0ff !important;
  font-weight: 800;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
}

.navbar-nav .nav-link {
  color: #e0e6f7 !important;
  font-weight: 600;
  font-size: 1.05rem;
  margin-right: 0.25rem;
  border-radius: 999px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0.4rem 1rem;
}

.navbar-nav .router-link-exact-active,
.navbar-nav .nav-link.router-link-active {
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023 !important;
  box-shadow: 0 0 12px rgba(31, 224, 255, 0.35);
}

.navbar-nav .nav-link:hover {
  background: rgba(31, 224, 255, 0.08);
  color: #1fe0ff !important;
}

.navbar-toggler {
  border-color: rgba(31, 224, 255, 0.3) !important;
  box-shadow: 0 0 8px rgba(31, 224, 255, 0.15);
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(31,224,255,1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

.main-bg {
  background: #0a1023;
  min-height: 100vh;
  width: 100vw;
}

.main-container {
  padding-top: 32px;
  padding-bottom: 32px;
}

::-webkit-scrollbar { width: 8px; }
::-webkit-scrollbar-track { background: #0a1023; }
::-webkit-scrollbar-thumb { background: #131b36; border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: rgba(31, 224, 255, 0.2); }

::selection { background: rgba(31, 224, 255, 0.25); }

.fade-enter-active { transition: opacity 0.25s ease, transform 0.25s ease; }
.fade-leave-active { transition: opacity 0.15s ease; }
.fade-enter-from { opacity: 0; transform: translateY(8px); }
.fade-leave-to { opacity: 0; }
</style> 